import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { selectors as ThreadsSelectors } from 'data/threads'
import { selectors as CommentsSelectors } from 'data/comments'

const enhance = connect((state, { noteActivity }) => {
  const { threadId, commentId } = noteActivity.get('metadata').toJS()

  const displayCommentId =
    commentId || ThreadsSelectors.getThreadCommentIds(state, threadId)[0]

  return {
    comment: CommentsSelectors.getComment(state, displayCommentId),
    thread: ThreadsSelectors.getThread(state, threadId),
  }
})

class ItemSubtitleComment extends React.Component {
  static propTypes = {
    noteActivity: PropTypes.object.isRequired,
    thread: PropTypes.object,
    comment: PropTypes.object,
  }

  render() {
    const { thread, comment, noteActivity } = this.props

    const hasHighlight = Boolean(thread) && Boolean(thread.get('highlight'))
    const commentExcerpt = comment
      ? comment.get('content')
      : noteActivity.get('metadata').get('excerpt')

    return (
      <div className="border-left-medium border-yellow shade-10 padding-horizontal-medium margin-top-normal">
        {hasHighlight && (
          <div className="comment-highlighted margin-bottom-small inline-block">
            {thread.get('highlight')}
          </div>
        )}
        <div>{commentExcerpt}</div>
      </div>
    )
  }
}

export default enhance(ItemSubtitleComment)
